/**
 * Formatação e escape, num lugar só.
 *
 * Existe por causa de um ganho concreto da saída do Apps Script: lá, cada
 * `.html` é um arquivo isolado que não enxerga o outro, então `_imgSrc()` e
 * `alertErro()` viviam COPIADOS em três arquivos — e uma correção precisava ser
 * feita três vezes, com o risco óbvio de ser feita em duas. Aqui há import, e
 * essas funções passam a ter uma versão só.
 */

/**
 * Texto vindo do banco pronto para entrar em HTML.
 *
 * Usa o próprio navegador para escapar em vez de trocar caracteres à mão: a
 * lista de caracteres perigosos é fácil de escrever incompleta, e o
 * `textContent` não tem como errar. Nome de fornecedor com `&` e observação com
 * `<` são reais aqui — não é hipótese.
 */
export function escapar(s: string): string {
  const d = document.createElement('div');
  d.textContent = s;
  return d.innerHTML;
}

/** "há 2 horas" diz mais que a data crua quando o que importa é a espera. */
export function quando(iso: string): string {
  const ms = Date.now() - new Date(iso).getTime();
  const min = Math.floor(ms / 60000);
  if (min < 1) return 'agora';
  if (min < 60) return `há ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `há ${h}h`;
  const d = Math.floor(h / 24);
  if (d === 1) return 'ontem';
  if (d < 30) return `há ${d} dias`;
  return 'em ' + new Date(iso).toLocaleDateString('pt-BR');
}

export function dataHora(iso: string): string {
  const d = new Date(iso);
  return (
    d.toLocaleDateString('pt-BR') +
    ' às ' +
    d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
  );
}

/**
 * Número como o Brasil escreve, sem casa decimal à toa.
 *
 * Quantidade de material é quase sempre inteira (12 sacos), mas nem sempre
 * (2,5 m³ de areia). Mostrar "12,00" polui a tabela inteira para atender a
 * exceção; mostrar "2,5" quando é o caso não atrapalha ninguém.
 */
export function numero(v: number): string {
  return v.toLocaleString('pt-BR', { maximumFractionDigits: 3 });
}
